import React from "react";
import "./style.css";

const Loader = () => {
  return (
    <div className="body">
      <div className="main">
        <div className="b">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;

export const DownloadLoader = () => {
  return (
    <div className="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
